import { render, staticRenderFns } from "./OneCategoryTreeItem.vue?vue&type=template&id=3fa61530&scoped=true&"
import script from "./OneCategoryTreeItem.vue?vue&type=script&lang=ts&"
export * from "./OneCategoryTreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./OneCategoryTreeItem.vue?vue&type=style&index=0&id=3fa61530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa61530",
  null
  
)

export default component.exports